import React from 'react'
import { HiOutlineLightningBolt } from 'react-icons/hi'
import { HiOutlineCheck, HiOutlineClock } from 'react-icons/hi2'
import type { StatusIcon } from '../types'

interface StatusPillProps {
  text: string
  icon?: StatusIcon | null
}

const iconClasses = 'w-4 h-4'

const statusIcons: Record<string, React.ReactNode> = {
  lightning: <HiOutlineLightningBolt className={iconClasses} aria-hidden="true" />,
  check: <HiOutlineCheck className={iconClasses} aria-hidden="true" />,
  clock: <HiOutlineClock className={iconClasses} aria-hidden="true" />,
}

function getStatusIcon(icon: StatusIcon | null | undefined) {
  return statusIcons[icon ?? ''] ?? null
}

export const StatusPill: React.FC<StatusPillProps> = ({ text, icon }) => {
  const statusIcon = getStatusIcon(icon)

  return (
    <div className="flex items-center justify-center">
      <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-civo-lime rounded-full">
        {statusIcon}
        <span className="body-small font-medium text-black whitespace-nowrap">
          {text}
        </span>
      </span>
    </div>
  )
}
